const initialState = {
    pageNo: 0,
    openPageData: [],
    profileData: {},
    openCount: null,
    expertReqId: null,
    tabSearchValue: '',
    domainFilter: [],
    sortChange: false,
    sortOptions: [{ id: '1', value: "recently asked", label: "Latest", origValue: 'questionAsked', sortOrder: 'desc' },
    { id: '2', value: "oldest asked", label: "Oldest", origValue: 'questionAsked', sortOrder: 'asc' },
    { id: '3', value: "answered", label: "Answered", origValue: 'answered', sortOrder: 'asc' },
    { id: '4', value: "unanswered", label: "Unanswered", origValue: 'answered', sortOrder: 'desc' },
    ],
    sortFilterVal: { id: "1", value: "recently asked", label: "Latest Asked", origValue: 'questionAsked', sortOrder: 'desc' },
    ownRecords: true,
    expertSelectOptions: [{ value: "assigned to me", label: "Assigned to Me" }, { value: "assigned to others", label: "Assigned to Others" }],
    isLoading: false,
    selectedQuestion: "",
    acknowledge: false,
    userData: null,
    searchData: [],
    ansStapled: [],
    isLoadingSearchData: false,
    selectedAnswerText: {},
    isEdit: false,
    index: null,
    outOfOffice: [],
    getSelectedDomain: "",
    reloadPage: 'refresh',
    relevanceObj: { id: '3', value: "relevance", label: "Relevance", origValue: 'relevance', sortOrder: 'asc' },
    isDeclined:false,
    refreshed:"",
    isOpenQuestion:false,
    keyTagsData:null,
    getScrollPosition:0
};
// getIsOpenedQuestion
const expertDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case "getIsOpenedQuestion":
            state = { ...state, isOpenQuestion: action.payload }
            return state;
        case "updatepagenumberexpertopentab":
            state = { ...state, pageNo: action.payload }
            state = {...state, getScrollPosition: 0}
            return state;
        case "getexpertopenpagedata":
            // if(state.pageNo === 0){
            //     state = { ...state, openPageData: action.payload }
            // }else{
            //     let newData = state.openPageData.concat(action.payload);
            //     state = { ...state, openPageData: newData }
            // }
            state = {...state, openPageData:action.payload}
            return state;
        case "expertdataprofile":
            state = { ...state, profileData: action.payload }
            return state;
        case "openquestionscountexpert":
            state = { ...state, openCount: action.payload }
            return state;
        case "getexpertrequestuuid":
            state = { ...state, expertReqId: action.payload }
            return state;
        case "tabsearchinputvalue":
            state = { ...state, tabSearchValue: action.payload }
            state = {...state, getScrollPosition:0}
            return state;
        case "getdomainsforexpert":
            state = { ...state, pageNo: 0 }
            state = { ...state, openPageData: [] }
            state = { ...state, domainFilter: action.payload }
            state = {...state, getScrollPosition:0}
            return state;
        case "sortChangeExpertOpenPage":
            state = { ...state, pageNo: 0 }
            state = { ...state, openPageData: [] }
            state = { ...state, sortChange: action.payload }
            state = {...state, getScrollPosition:0}
            return state;
        case "sortfiltervalueaddexpert":
            state = { ...state, pageNo: 0 }
            state = { ...state, openPageData: [] }
            state = { ...state, sortFilterVal: action.payload }
            state = {...state, getScrollPosition:0}
            return state;
        case "ownrecordsexpert":
            state = { ...state, pageNo: 0 }
            state = { ...state, openPageData: [] }
            state = { ...state, ownRecords: action.payload }
            state = {...state, getScrollPosition:0}
            return state;
        case "expertdataloading":
            state = { ...state, isLoading: action.payload }
            return state;
        case "selectedquestion":
            state = { ...state, selectedQuestion: action.payload }
            return state;
        case "getacknowledgestatus":
            state = { ...state, selectedQuestion: action.payload }
            return state;
        case "getforcererouteusers":
            let newPayload = {...action.payload}
            // let newUsers = newPayload.users.length > 0 && newPayload.users.map((obj,ind)=>{
            //     let newObj = {...obj, isDisabled:true,"Assigned to Userrs": obj.questionAssigned && [{...obj,label:obj.firstName + obj.lastName,name:obj.firstName + obj.lastName}], label:obj.firstName + " " + obj.lastName,value:obj.userUuid}
            //     return newObj;
            // })
            let assignedExperts = newPayload.users.filter((obj)=>{
                if(obj.questionAssigned)
                {
                    return obj;
                }
            }).map((obj,ind)=>{
                let newObj = {...obj, label:obj.firstName + " " + obj.lastName, value:obj.userUuid,isDisabled:true}
                return newObj
            })
            let chooseExperts = newPayload.users.filter((obj)=> {
                if(obj.questionAssigned === false)
                {
                    return obj;
                }
            }).map((obj,ind)=>{
                let newObj = {...obj, label:obj.firstName + " " + obj.lastName, value:obj.userUuid}
                return newObj
            })
            let newArr = [{label:'Assigned Experts',options:assignedExperts,isDisabled:true},{
                label:'Choose an Expert',options:chooseExperts
            }]
            newPayload.users = newArr;
            let newPayload2 = {...newPayload}
            state = { ...state, userData: newPayload2 }
            return state;
        case "getsearchdataforknowledgeEntry":
            state = { ...state, searchData: action.payload }
            return state;
        case "getstapledanswer":
            state = { ...state, ansStapled: action.payload }
            return state;
        case "dataloadingsuggestions":
            state = { ...state, isLoadingSearchData: action.payload }
            return state;
        case "getselectedanswertext":
            state = { ...state, selectedAnswerText: action.payload }
            return state;
        case "enableupdatebutton":
            state = { ...state, isEdit: action.payload }
            return { ...state, isEdit: !state.isEdit };
        case "getindexoutofoffice":
            state = { ...state, index: action.payload }
            return state;
        case "outofofficedata":
            state = { ...state, outOfOffice: action.payload }
            return state;
        // return { ...state, outOfOffice: [...state.outOfOffice, action.payload] }
        case "removeindexoutofoffice":
            return { ...state, outOfOffice: state.outOfOffice.filter((index) => index.id !== action.payload) }
        case "getselecteddomain":
            state = { ...state, getSelectedDomain: action.payload }
            return state;
        case "refreshopenpagedata":
            state = { ...state, reloadPage: action.payload }
            return state;
        case "addrelevanceexpertopen":
            state = { ...state, relevanceObj: action.payload };
            return state;
        case "updatesortexpertopenoption":
            state = { ...state, sortOptions: action.payload };
            return state;
        case "checkquestiondeclinestatus":
            state = {...state, isDeclined:action.payload}
            return state;
        case "refreshexpertopentabdata":
            state = {...state, pageNo:0}
            state = {...state, refreshed:action.payload}
            return state;
        case "getkeytagsinexpertopen": 
        state = {...state, keyTagsData:action.payload}
        return state;
        case "getscrollposition": 
        state = {...state, getScrollPosition:action.payload}
        return state;
        default:
            return state;
    }
};

export default expertDataReducer;
